/*
 * @Author: zhangyuan your_email
 * @Date: 2024-11-20 13:47:28
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2025-11-20 10:44:43
 * @FilePath: /report-optimus-h5/src/views/promise_frame/modeules.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
    'navigationH5',
    'navigationH5en',
    'navigationH5ru',

    'carInfoH5Battery',
    'carInfoH5BatteryHM',
    'carInfoH5BatteryEn',
    'carInfoH5BatteryRu',
    
    'detectManH5',
    'detectManH5En',
    'detectManH5Ru',

    'entrustDetectH5',
    'entrustDetectH5En',
    'entrustDetectH5Ru',
    
    'loopCarVideoH5',
    'loopCarVideoH5En',
    'loopCarVideoH5Ru',

    'remarkH5',
    'remarkH5En',
    'remarkH5Ru',

    'reminderH5',
    'reminderH5En',
    'reminderH5Ru',

    'ecuH5',
    'ecuH5Plus2503',
    'ecuH5PlusEn',
    'ecuH5PlusRu',
    
    'serviceDescH5SOH',
    'serviceDescH5Battery',
    'serviceDescH5BatteryHM',
    
    'summaryH5Battery',
    'summaryH5BatterySOH',
    'summaryH5BatteryOverdue',
    'summaryH5BatteryHM',
    'summaryH5BatteryEn',
    'summaryH5BatteryRu',
    'summaryH5BatterySOHEn',
    'summaryH5BatterySOHRu',
    'summaryH5BatteryOverdueEn',
    'summaryH5BatteryOverdueRu',
    
    'checkItemH5',
    'checkItemH5PromiseBattery',
    'checkItemH5PromiseBatteryHM',
    'checkItemH5PromiseBatteryEn',
    'checkItemH5PromiseBatteryRu',

    'batteryDetectH5',
    'batteryDetectH5SOH',
    'batteryDetectH5HM',
    'batteryDetectH5En',
    'batteryDetectH5SOHEn',
    'batteryDetectH5SOHRu'


]